import React, { Component } from "react";
import {
  ScrollView,
  View,
  StyleSheet,
  Dimensions,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";

import { translate, CurrentLocale, IS_WEB } from "../locales/translate";
import Loading from "../components/Loading";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faCircle } from "../../assets/consts/faCharCodes";
import DateRangePicker from "../components/DateRangePicker";
import { BarChart, PieChart } from "react-native-chart-kit"; // has issue with persian text
import Timeline from "react-native-timeline-flatlist";
import { ArButton } from "../argon-ui";
import Theme from "../argon-ui/Theme";
import Switch from "../components/ToggleSwitch";
import { Box, VStack } from "native-base";

// const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("window").width;
const IS_MOBILE = (Platform.OS == "android") | (Platform.OS == "ios");
class AreaLogScreen extends Component {
  constructor(props) {
    super(props);
    let _areaId = 0;
    let _areaUId = "";
    if (
      this.props.navigation.state.params &&
      this.props.navigation.state.params.areaId &&
      this.props.navigation.state.params.areaUId
    ) {
      _areaId = this.props.navigation.state.params.areaId;
      _areaUId = this.props.navigation.state.params.areaUId;
    }

    this.state = {
      isLoading: true,
      serverUrl: undefined,
      accessToken: undefined,
      buildingId: "",
      areaId: _areaId,
      areaUId: _areaUId,
      areaName: "",
      consumptionData: [],
      devicesConsumptionData: [],
      consumptionTotalUsage: "",
      showDatePicker: false,
      dateFrom: null,
      dateTo: null,
      duration: "today",
      customDuration: "daily",
      locale: CurrentLocale,
      timeLine: [],
      timelineFilters: {
        isLoadingMore: false,
        page: 1,
        withDevice: true,
        withUser: true,
        withScenario: true,
        withArm: true,
        withState: true,
      },
    };

    this.consumptionChartRef = undefined;

    this.colorSet = [
      "#36a2eb",
      "#ff6384",
      "#cc65fe",
      "#ffce56",
      "#5cb85c",
      "#f0ad4e",
      "#0275d8",
      "#d9534f",
    ];
    // for (var i in ArTheme.COLORS) {
    //   this.colorSet.push(ArTheme.COLORS[i]);
    // }
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreasList"),
  });
  componentDidMount() {
    let { currentServer, currentBuilding, serverUrl } = this.props.appReducer;
    this.setState(
      {
        serverUrl,
        accessToken: currentServer.accessToken,
        buildingId: currentBuilding?.buildingId || "",
      },
      () => {
        this.getAllReports();
      }
    );

    if (this.state.areaId) {
      let { areas } = this.props.reducer;
      for (var i in areas) {
        let area = areas[i];
        if (
          area.areaId == this.state.areaId ||
          area.areaUId == this.state.areaId
        ) {
          this.setState({ areaName: area.areaName });
          break;
        }
      }
    }
  }

  getAllReports = () => {
    this.getConsumptionReport();
    this.getTopConsumingDevicesReport();
    this.getTimelineLog();
  };

  getConsumptionReport = () => {
    let {
      serverUrl,
      accessToken,
      buildingId,
      dateFrom,
      dateTo,
      duration,
      customDuration,
      areaId,
      areaUId,
      locale,
    } = this.state;
    this.setState({ isLoading: true, showDatePicker: false });
    if (serverUrl) {
      // filters
      if (!serverUrl.endsWith("/")) serverUrl += "/";

      var filters = [];
      filters.push(`buildingId=${buildingId}`);
      if (dateFrom) filters.push(`from=${new Date(dateFrom).toDateString()}`);

      if (dateTo) filters.push(`to=${new Date(dateTo).toDateString()}`);

      if (duration) filters.push(`duration=${duration}`);

      if (customDuration) filters.push(`customDuration=${customDuration}`);

      filters.push(`locale=${locale || ""}`);

      if (areaId) {
        filters.push(`id=${areaId}`);
      }
      if (areaUId) {
        filters.push(`uId=${areaUId}`);
      }
      // end filters

      var url = `${serverUrl}PowerConsumption/Area?${filters.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          this.setState({
            isLoading: false,
          });
          return res.json();
        })
        .then((resj) => {
          if ((resj?.areaId || resj.areaUId) && resj.logs != null) {
            this.setState({
              consumptionData: resj.logs,
              consumptionTotalUsage: `${resj.totalUsage} ${resj.unit}`,
              isLoading: false,
            });
          } else {
            this.setState({
              serverAuthErrors: resj.errors,
              isLoading: false,
            });
          }
        })
        .catch((err) => {
          {
            console.log("error on getConsumptionReport", err);
            this.setState({ isLoading: false });
          }
        });
    }
  };

  getTopConsumingDevicesReport = () => {
    let {
      serverUrl,
      accessToken,
      buildingId,
      dateFrom,
      dateTo,
      duration,
      customDuration,
      areaId,
      areaUId,
      locale,
    } = this.state;
    this.setState({ isLoading: true, showDatePicker: false });
    if (serverUrl) {
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      // filters
      var filters = [];
      filters.push(`buildingId=${buildingId}`);
      if (dateFrom) filters.push(`from=${new Date(dateFrom).toDateString()}`);

      if (dateTo) filters.push(`to=${new Date(dateTo).toDateString()}`);

      if (duration) filters.push(`duration=${duration}`);

      if (customDuration) filters.push(`customDuration=${customDuration}`);

      if (areaId) {
        filters.push(`id=${areaId}`);
      }
      if (areaUId) {
        filters.push(`uId=${areaUId}`);
      }
      filters.push(`locale=${locale || ""}`);
      // end filters
      // console.log('filters in AreaLogScreen.getTopConsuming', filters)
      var url = `${serverUrl}PowerConsumption/AreaTopDevices?${filters.join(
        "&"
      )}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          this.setState({
            isLoading: false,
          });
          return res.json();
        })
        .then((resj) => {
          if ((resj?.areaId || resj.areaUId) && resj.logs != null) {
            this.setState({
              devicesConsumptionData: resj.logs,
              isLoading: false,
            });
          } else {
            this.setState({
              serverAuthErrors: resj.errors,
              isLoading: false,
            });
          }
        })
        .catch((err) => {
          {
            console.log("error on getTopConsumingDevicesReport", err);
            this.setState({ isLoading: false });
          }
        });
    }
  };

  toggleDatePicker = () => {
    this.setState({ showDatePicker: !this.state.showDatePicker });
  };

  handleOnDatePick = (tick, p) => {
    let f = this.state.dateFrom != null;
    let t = this.state.dateTo != null;
    if (p == "START_DATE") {
      //(f && t) || (!f && !t) both are selected or both are empty
      // set from date and clear toDate
      this.setState({ dateFrom: tick, dateTo: null });
    } else {
      this.setState({ dateTo: tick });
    }
  };

  getTimelineLog = (keepLogs = false) => {
    let {
      serverUrl,
      accessToken,
      timelineFilters,
      buildingId,
      areaId,
      areaUId,
    } = this.state;
    timelineFilters.isLoadingMore = true;
    this.setState({
      isTimelineLoading: !keepLogs && true,
      timelineFilters,
    });
    if (serverUrl) {
      if (!serverUrl.endsWith("/")) serverUrl += "/";
      // filters
      var filters = [];
      filters.push(`buildingId=${buildingId}`);
      let { page, withScenario, withUser, withState, withArm } =
        this.state.timelineFilters;
      filters.push(`s=${withScenario}`);
      filters.push(`u=${withUser}`);
      filters.push(`a=${withArm}`); // keep filter for backward compatibility but hard coded to false.(area arm filter merged to area states in backend.)
      filters.push(`st=${withState}`);
      if (areaId) {
        filters.push(`id=${areaId}`);
      }
      if (areaUId) {
        filters.push(`uId=${areaUId}`);
      }
      if (page > 1) filters.push(`p=${page}`);

      // end filters

      var url = `${serverUrl}Log/AreaTimeLine?${filters.join("&")}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // body: JSON.stringify({
        // }),
      })
        .then((res) => {
          timelineFilters.isLoadingMore = false;

          this.setState({
            isTimelineLoading: false,
            timelineFilters,
          });
          return res.json();
        })
        .then((resj) => {
          if ((resj?.areaId || resj.areaUId) && resj.logs != null) {
            if (resj.p && resj.p > 1) {
              // for pages above 1, push new logs to old ones.
              timelineFilters.isLoadingMore = false;
              this.setState({
                timeLine: [...this.state.timeLine, ...resj.logs],
                isTimelineLoading: false,
                timelineFilters,
              });
            } else {
              // but if page is not specified or page == 1, override timeline with new logs.
              timelineFilters.isLoadingMore = false;

              this.setState({
                timeLine: resj.logs,
                isTimelineLoading: false,
                timelineFilters,
              });
            }
          } else {
            timelineFilters.isLoadingMore = false;

            this.setState({
              serverAuthErrors: resj.errors,
              isTimelineLoading: false,
              timelineFilters,
            });
          }
        })
        .catch((err) => {
          {
            console.log("error on getTimelineLog", err);
            timelineFilters.isLoadingMore = false;

            this.setState({ isTimelineLoading: false, timelineFilters });
          }
        });
    }
  };

  renderTimeline = () => {
    if (this.state.isTimelineLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View style={styles.section}>
        <View style={styles.timeLineWrapper}>
          <Text style={styles.chartTitle}>
            {translate("deviceLog.activities")}
          </Text>
          <View
            style={{
              flexDirection: "row",
              marginBottom: 15,
              marginHorizontal: 10,
              justifyContent: "center",
            }}
          >
            <View
              style={{
                flexDirection: "col",
                justifyContent: "space-between",
                width: "50%",
                marginBottom: 12,
              }}
            >
              {/* with device */}

              <Switch
                label={translate("deviceLog.areaarm")}
                labelStyle={styles.switchLabel}
                isOn={this.state.timelineFilters.withArm}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  let { timelineFilters } = this.state;
                  timelineFilters.withArm = v;
                  timelineFilters.page = 1;
                  this.setState({ timelineFilters }, () => {
                    this.getTimelineLog();
                  });
                }}
                animationSpeed={0}
              />

              {/* end with device */}
              {/* with user */}

              <Switch
                label={translate("deviceLog.user")}
                labelStyle={styles.switchLabel}
                isOn={this.state.timelineFilters.withUser}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  let { timelineFilters } = this.state;
                  timelineFilters.withUser = v;
                  timelineFilters.page = 1;
                  this.setState({ timelineFilters });
                  this.getTimelineLog();
                }}
                animationSpeed={0}
              />

              {/* end with user */}
            </View>
            <View
              style={{
                flexDirection: "col",
                justifyContent: "space-between",
                width: "50%",
                marginBottom: 12,
              }}
            >
              {/* with scenario */}

              <Switch
                label={translate("deviceLog.scenario")}
                labelStyle={styles.switchLabel}
                isOn={this.state.timelineFilters.withScenario}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  let { timelineFilters } = this.state;
                  timelineFilters.withScenario = v;
                  timelineFilters.page = 1;
                  this.setState({ timelineFilters });
                  this.getTimelineLog();
                }}
                animationSpeed={0}
              />

              {/* end with scenario */}
              {/* start with arm */}

              <Switch
                label={translate("deviceLog.areastate")}
                labelStyle={styles.switchLabel}
                isOn={this.state.timelineFilters.withState}
                onColor={Theme.COLORS.ACTIVE}
                offColor={Theme.COLORS.MUTED}
                size="small"
                onToggle={(v) => {
                  let { timelineFilters } = this.state;
                  timelineFilters.withState = v;
                  timelineFilters.page = 1;
                  this.setState({ timelineFilters });
                  this.getTimelineLog();
                }}
                animationSpeed={0}
              />
            </View>
          </View>
          <View style={{ paddingHorizontal: 10 }}>
            {this.state.timeLine && this.state.timeLine.length > 0 && (
              <View style={{ direction: "ltr" }}>
                <Timeline
                  data={this.state.timeLine}
                  columnFormat={
                    IS_MOBILE ? "single-column-left" : "single-column-right"
                  }
                  timeStyle={{
                    minWidth: 120,
                  }}
                  eventContainerStyle={{}}
                  renderDetail={(rowData) => {
                    // console.log("rowData.cause", rowData.cause);
                    return (
                      <View
                        style={{
                          backgroundColor: "#66999910",
                          borderRadius: 15,
                          borderColor: "#669999",
                          borderWidth: 1,
                          padding: 15,
                          flex: 1,
                        }}
                      >
                        {/* title */}
                        <Text style={{ fontWeight: "bold" }}>
                          {translate(`deviceLog.${rowData.cause}`)}:{" "}
                          {rowData.cause == "device"
                            ? translate(`deviceLog.${rowData.title}`)
                            : rowData.title}
                        </Text>
                        <View style={{}}>
                          {/* description */}
                          <Text style={{}}>
                            {rowData.cause === "reverse"
                              ? translate(`deviceLog.AutoDisableCommandSent`, {
                                  stateName: rowData.description,
                                })
                              : rowData.cause === "userpermissionchange"
                              ? rowData.description
                              : rowData.cause === "areabreach"
                              ? translate(`deviceLog.areaBreachDetectedBy`, {
                                  deviceName: rowData.description,
                                })
                              : rowData.description.indexOf("Armed") >= 0
                              ? translate(`deviceLog.${rowData.description}`)
                              : rowData.cause === "scenario" ||
                                rowData.cause === "user"
                              ? rowData.status <= 0
                                ? translate(`deviceLog.DeActivateCommandSent`, {
                                    stateName: rowData.description,
                                  })
                                : translate(`deviceLog.ActivateCommandSent`, {
                                    stateName: rowData.description,
                                  })
                              : translate(`deviceLog.${rowData.description}`)}
                          </Text>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            )}
          </View>
          {this.renderTimelineLoadMore()}
        </View>
      </View>
    );
  };

  renderTimelineLoadMore = () => {
    if (this.state.timelineFilters.isLoadingMore) {
      return <Loading message="" />;
    } else if (this.state.timeLine.length > 0) {
      return (
        <ArButton
          style={{ marginBottom: 20, alignSelf: "center" }}
          color="primary"
          onPress={() => {
            let { timelineFilters } = this.state;
            timelineFilters.page++;
            timelineFilters.isLoadingMore = true;
            this.setState({ timelineFilters }, () => {
              this.getTimelineLog(true);
            });
          }}
        >
          <Text style={{ color: "#FFF" }}>
            {translate("deviceLog.olderLogs")}
          </Text>
        </ArButton>
      );
    }
    return null;
  };

  render() {
    if (this.state.isLoading)
      return <Loading message={translate("app.pleaseWaite")} />;
    else
      return (
        <ScrollView style={{}}>
          <View style={{ alignItems: "center" }}>
            <Text
              style={{ fontSize: 18, fontWeight: "bold", paddingVertical: 10 }}
            >
              {this.state.areaName}
            </Text>
            <DateRangePicker
              duration={this.state.duration}
              customDurationType={this.state.customDuration}
              from={this.state.dateFrom}
              to={this.state.dateTo}
              onDurationChange={(duration) => {
                this.setState({ duration }, () => {
                  if (duration != "custom") {
                    this.getAllReports();
                  }
                });
              }}
              onDateChange={this.handleOnDatePick}
              onRefresh={this.getAllReports}
              onCustomDurationTypeChange={(type) =>
                this.setState({ customDuration: type })
              }
            />
            <VStack
              space="2"
              justifyContent="space-around"
              flexDirection={{
                md: "row",
              }}
            >
              {this.state.consumptionData &&
                this.state.consumptionData.length > 0 && (
                  <View style={styles.chartWrapper}>
                    <Text style={styles.chartTitle}>
                      {translate("deviceLog.powerConsumption")}
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Text
                        style={{
                          paddingHorizontal: 10,
                          // borderWidth: 1,
                          // borderColor: "red",
                          //flex: 1,
                        }}
                      >
                        {translate("deviceLog.totalUsage")}:
                      </Text>
                      <Text style={styles.totalUsageText}>
                        {this.state.consumptionTotalUsage}
                      </Text>
                    </View>
                    <BarChart
                      ref={(ref) => (this.consumptionChartRef = ref)}
                      data={{
                        labels: this.state.consumptionData.map((cd, idx) =>
                          idx % 2 == 1 &&
                          ((cd.label && cd.label.length > 2) ||
                            this.state.consumptionData.length > 10)
                            ? ""
                            : cd.label
                        ),
                        datasets: [
                          {
                            data: [
                              ...this.state.consumptionData.map(
                                (cd) => cd.value
                              ),
                            ],
                          },
                        ],
                      }}
                      width={360} // from react-native
                      height={220}
                      yAxisLabel=""
                      yAxisSuffix=""
                      yAxisInterval={1} // optional, defaults to 1
                      showBarTops={true}
                      fromZero={this.state.consumptionData.some(
                        (d) => d.value < 10
                      )}
                      chartConfig={{
                        data: this.state.consumptionData,
                        barPercentage:
                          this.state.consumptionData &&
                          this.state.consumptionData.length > 0
                            ? (1 / this.state.consumptionData.length) * 7 // calculated width as 70% of width divided by columns count
                            : 0.5, // or default as 0.5
                        backgroundColor: "#e26a00",
                        backgroundGradientFrom: "#fb8c00",
                        backgroundGradientTo: "#ffa726",
                        decimalPlaces: 2, // optional, defaults to 2dp
                        color: (opacity = 1) =>
                          `rgba(255, 255, 255, ${opacity})`,
                        labelColor: (opacity = 1) =>
                          `rgba(255, 255, 255, ${opacity})`,
                        style: {
                          borderRadius: 16,
                        },
                        propsForDots: {
                          r: "6",
                          strokeWidth: "2",
                          stroke: "#ffa726",
                        },
                        propsForLabels: {
                          //transform: "rotate(90)",
                        },
                      }}
                      //bezier
                      style={{
                        marginVertical: 8,
                        borderRadius: 16,
                      }}
                    />
                  </View>
                )}
              {this.state.devicesConsumptionData &&
                this.state.devicesConsumptionData.length > 0 && (
                  <View style={styles.chartWrapper}>
                    <Text style={styles.chartTitle}>
                      {translate("deviceLog.AreaTopPowerConsumingDevices")}
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        // width: SCREEN_WIDTH * 0.9,
                        width: "100%",
                      }}
                    >
                      <View style={{ flex: 1, paddingTop: 5 }}>
                        {this.state.devicesConsumptionData.map((l, i) => {
                          return (
                            <View
                              key={i}
                              style={{
                                flexDirection: "row",
                                paddingVertical: 6,
                                alignItems: "center",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                color={this.colorSet[i % this.colorSet.length]}
                                size={12}
                              />
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Text style={{ paddingHorizontal: 3 }}>
                                  {l.label == "otherDevices"
                                    ? translate("deviceLog.otherDevices")
                                    : l.label}
                                </Text>
                                <Text
                                  style={{
                                    color: Theme.COLORS.MUTED,
                                    fontSize: 9,
                                  }}
                                >
                                  ({l.value} {"KWh"})
                                </Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                      <View style={{ flex: 1, width: "100%" }}>
                        <PieChart
                          data={this.state.devicesConsumptionData.map(
                            (d, i) => {
                              return {
                                name: d.label,
                                value: d.value,
                                color: this.colorSet[i % this.colorSet.length],
                              };
                            }
                          )}
                          chartConfig={{
                            backgroundColor: "#fff",
                            // backgroundGradientFrom: "#fb8c00",
                            // backgroundGradientTo: "#ffa726",
                            decimalPlaces: 2, // optional, defaults to 2dp
                            color: (opacity = 1) =>
                              `rgba(255, 255, 255, ${opacity})`,
                            labelColor: (opacity = 1) =>
                              `rgba(255, 255, 255, ${opacity})`,
                            style: {
                              borderRadius: 16,
                            },
                            propsForDots: {
                              r: "6",
                              strokeWidth: "2",
                              stroke: "#ffa726",
                            },
                            propsForLabels: {
                              //transform: "rotate(90)",
                            },
                          }}
                          // width={SCREEN_WIDTH / 2} //{-10+SCREEN_WIDTH / 2} // from react-native
                          width={220} //{-10+SCREEN_WIDTH / 2} // from react-native
                          height={220} //{220}
                          accessor="value"
                          backgroundColor="transparent"
                          center={[IS_WEB ? 130 : 60, IS_WEB ? 100 : 0]}
                          hasLegend={false}
                        />
                      </View>
                    </View>
                  </View>
                )}
            </VStack>
          </View>
          {this.renderTimeline()}
        </ScrollView>
      );
  }
}

const styles = StyleSheet.create({
  chartWrapper: {
    marginHorizontal: 3,
    marginVertical: 5,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.BLOCK,
    // width: "100%",
  },
  chartTitle: {
    fontSize: 18,
    padding: 10,
    fontWeight: "bold",
  },
  totalUsageText: {
    fontWeight: "bold",
    fontSize: 25,
    textAlign: "left",
    writingDirection: "ltr",
    color: Theme.COLORS.MUTED,
    // borderWidth: 1,
    // borderColor: "green",
    //flex: 1,
  },
  switchLabel: {
    minWidth: 100,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaLogScreen);
